//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProductsMixin from '~/components/products/mixins/ProductsMixin'

export default {

    name: 'ProductsIndex',

    mixins: [ProductsMixin],

    props: {
        page: {
            type: String,
            default: '1'
        }
    },

    data() {
        return {
            paginationUrlRewrite: true,
        }
    },

    watch: {
        '$route.query': '$fetch',

        '$fetchState.pending': function (newState, oldState) {
            if(newState === true) {
                this.$meta().pause()
                this.$store.commit('tracking/status', 'waiting')
            } else {
                this.$store.commit('tracking/status', 'ready')
                this.$meta().resume()
            }
        }
    },


    async fetch() {

       const params = {
           page: this.page
       }

       try {

           const response = await this.$axios.$get(this.$ziggy.route('api.products.search'), {
               params
           })

           this.products = response.data
           this.links = response.links
           this.meta = response.meta

       } catch (e) {
           this.$logger.captureExceptionAxios(e)
       }

   },
}

